module.exports = __webpack_public_path__ + "media/images/athletes/1903-549311c7037ed96aa703e104ab44bd6d.png";